// Modules
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// UI
import { SidebarItem, SidebarLabel } from 'components/catalyst/sidebar';
import { Globe } from 'lucide-react';

// Utils
import { useAppDispatch, useAppSelector } from 'app/store';
import { setLanguage } from 'features/ui/uiSlice';
import { SupportedLanguage } from 'i18n';
import clsx from 'clsx';

interface LanguageSelectorProps {
  isMinimized?: boolean;
}

const LanguageSelector: FC<LanguageSelectorProps> = ({ isMinimized = false }) => {
  const { i18n } = useTranslation('common');
  const dispatch = useAppDispatch();
  const currentLanguage = useAppSelector((state) => state.ui.language);

  const handleToggleLanguage = () => {
    const newLang: SupportedLanguage = currentLanguage === 'en' ? 'es' : 'en';
    dispatch(setLanguage(newLang));
    i18n.changeLanguage(newLang);
  };

  const languageLabel = currentLanguage === 'en' ? 'English' : 'Español';

  return (
    <SidebarItem 
      onClick={handleToggleLanguage} 
      className={clsx(
        'cursor-pointer',
        isMinimized && 'justify-center'
      )}
      title={isMinimized ? languageLabel : undefined}
    >
      <Globe size={16} />
      {!isMinimized && <SidebarLabel>{languageLabel}</SidebarLabel>}
    </SidebarItem>
  );
};

export default LanguageSelector;
